import { Grid, TextField } from "@mui/material";
import { useGetPartitionById, useGetPartitionCallOffCodeById } from "../../services/use-partition-api";

import { CallOffCodeChips } from "../call-off-code-chips";
import { FC } from "react";
import { NodePath } from "domains/nodes/components/node-path";
import localisations from "domains/partitions/localisation";

interface PartitionDetailsProps {
    partitionId: string;
}

const PartitionDetails: FC<PartitionDetailsProps> = (props) => {
    const { loading, data } = useGetPartitionById(props.partitionId, true);
    const callOffCode = useGetPartitionCallOffCodeById(props.partitionId);

    const { calloffCodesTitle } = localisations;

    return (
        <>
            {!loading && data !== null ? (
                <>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12}>
                            <Grid item marginBottom={2}>
                                <NodePath
                                    nodeId={data?.parentHierarchyNodeId ?? null}
                                    labelText={localisations.pathLabel}
                                ></NodePath>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={6}>
                            <Grid item marginBottom={2}>
                                <TextField
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    fullWidth
                                    id="partition-name"
                                    inputProps={{ "aria-labelledby": "partition-name" }}
                                    label={localisations.nameLabel}
                                    defaultValue={data?.name ?? ""}
                                />
                            </Grid>
                            <Grid item marginBottom={2}>
                                <TextField
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    fullWidth
                                    id="partition-reference"
                                    inputProps={{ "aria-labelledby": "partition-reference" }}
                                    label={localisations.referenceLabel}
                                    defaultValue={data?.reference ?? ""}
                                />
                            </Grid>
                            <Grid item marginBottom={2}>
                                <TextField
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    fullWidth
                                    id="partition-owner-email"
                                    inputProps={{ "aria-labelledby": "partition-owner-email" }}
                                    label={localisations.ownerEmailLabel}
                                    defaultValue={data?.ownerEmail ?? ""}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={6} marginBottom={2}>
                            <TextField
                                InputProps={{
                                    readOnly: true,
                                }}
                                fullWidth
                                id="partition-notes"
                                inputProps={{ "aria-labelledby": "partition-notes" }}
                                label={localisations.notesLabel}
                                defaultValue={data?.notes ?? ""}
                                multiline
                                minRows={7}
                                maxRows={8}
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Grid item marginBottom={2}>
                                {callOffCode.data ? (
                                    <CallOffCodeChips
                                        style={{ marginLeft: 10, marginBottom: 10 }}
                                        title={calloffCodesTitle}
                                        callOffCodes={callOffCode.data.callOffCodes ?? []}
                                        deletable={false}
                                    ></CallOffCodeChips>
                                ) : null}
                            </Grid>
                        </Grid>
                    </Grid>
                </>
            ) : null}
        </>
    );
};

export default PartitionDetails;
